module.exports = __webpack_public_path__ + "static/img/Dayne-Zorko.20b4bde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dayne-Zorko.jpg
// module id = B1qy
// module chunks = 0